import { render } from "./Navigation.vue?vue&type=template&id=12f3807e&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=12f3807e&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f3807e"]])

export default __exports__